document.addEventListener('DOMContentLoaded', function () {
  const sidebar = document.querySelector('.sidebar');
  const toggleButton = document.querySelector('.sidebar-toggle');
  const sidebarMenu = document.getElementById('sidebar-menu');
  const menuItems = document.querySelectorAll('.sidebar-menu-item');
  const currentPath = window.location.pathname;

  // Handle sidebar toggle
  if (toggleButton && sidebarMenu) {
    toggleButton.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true' || false;
      this.setAttribute('aria-expanded', !expanded);

      // Add content animation
      sidebarMenu.classList.toggle('active');
      const content = document.querySelector('.sidebar-content');
      if (content) {
        content.classList.toggle('open');
      }

      toggleButton.classList.toggle('active');
    });
  }

  // Handle menu items and active states
  menuItems.forEach((item) => {
    const link = item.querySelector('a');
    const toggleButton = item.querySelector('.dropdown-toggle');
    const toggleButton1 = document.querySelector('.sidebar-toggle');
    // Set active state based on current URL
    if (link && link.getAttribute('href') === currentPath) {
      item.classList.add('active');
      const tempEl = document.createElement('div');
      tempEl.innerHTML = link.innerHTML;
      const newLinkText = tempEl.textContent;
      const iconElement = toggleButton1.querySelector('.toggle-icon');

      if (iconElement) {
        toggleButton1.innerHTML = `${newLinkText} ${iconElement.outerHTML}`;
      } else {
        toggleButton1.textContent = newLinkText;
      }
      // If item is in dropdown, expand parent
      const parentDropdown = item.closest('.sidebar-dropdown');
      if (parentDropdown) {
        parentDropdown.classList.add('active');
      }
    }

    // Handle dropdown toggles
    if (toggleButton) {
      toggleButton.addEventListener('click', function (event) {
        event.preventDefault();
        item.classList.toggle('active');
      });
    }
  });
});